import { IS_SMALL_LOAN_PROGRAM_PRODUCT_ENABLED } from 'constants/constants';
import {
  MIN_LOAN_FOR_PORTAL,
  MIN_LOAN_FOR_PORTAL_WITH_SMALL_LOAN_PROGRAM,
} from 'prequalificationV2/pages/PreQualification/steps/LoanInformation/loanInformation.constants';

export const checkUserShouldBeRedirectToFinMktPortal = (loanAmount: number) => {
  if (IS_SMALL_LOAN_PROGRAM_PRODUCT_ENABLED) {
    return loanAmount < MIN_LOAN_FOR_PORTAL_WITH_SMALL_LOAN_PROGRAM;
  }

  return loanAmount < MIN_LOAN_FOR_PORTAL;
};
